module.exports = __webpack_public_path__ + "kw.398bcf75.svg";